<mat-accordion>
    <mat-expansion-panel hideToggle (opened)="panelOpenState = true" (closed)="panelOpenState = false"
        #mep="matExpansionPanel">
        <mat-expansion-panel-header>
            <div class="table-container" *ngIf="!transaction_list_mobile; else transactionListMobile">
                <div class="table-row">
                    <div class="sub-table-title-pucture">
                        <div class="table-cell container-info-transaction">
                            <div>
                                <p class="date-transaction secondary-text">{{transaction.attributes.created_at |
                                    date:'dd/MM/YYYY'}}</p>
                                <p class="mid-transaction color-heading">{{transaction.attributes.mid}}</p>
                            </div>
                        </div>
                        <div class="table-cell title-picture-container">
                            <div class="send-and-receive-titles">
                                <p class="secondary-text color-heading">Envías</p>
                                <span
                                    class="secondary-text">{{transaction.relationships.system1.data!.attributes.currency}}</span>
                            </div>
                            <div class="amount-picture-container">
                                <app-system-picture class="system-picture"
                                    [systemId]="(opacity ? transaction.relationships.system1.data?.id + '-comprar' : transaction.relationships.system1.data?.id )?? ''"
                                    [alt]="transaction.relationships.system1.data!.attributes.name"
                                    title="Comprar/Vender {{transaction.relationships.system1.data!.attributes.name}}"></app-system-picture>
                                <p class="number-amount color-heading">{{transaction.attributes.amount1 | decimalBySystem:
                                    transaction.relationships.system1.data!}}
                                </p>
                            </div>
                        </div>
                        <div class="table-cell title-picture-container">
                            <div class="send-and-receive-titles">
                                <p class="secondary-text color-heading">Enviamos</p>
                                <span
                                    class="secondary-text color-heading">{{transaction.relationships.system2.data!.attributes.currency}}</span>
                            </div>
                            <div class="amount-picture-container">
                                <app-system-picture class="system-picture"
                                    [systemId]="(opacity ? transaction.relationships.system2.data?.id + '-comprar' : transaction.relationships.system2.data?.id )?? ''"
                                    [alt]="transaction.relationships.system2.data!.attributes.name"
                                    title="Comprar/Vender {{transaction.relationships.system2.data!.attributes.name}}"></app-system-picture>
                                <p class="number-amount color-heading">{{ getAmountBySystem() | decimalBySystem: transaction.relationships.system2.data! }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="table-cell">
                        <div class="button--disappear"
                            [ngClass]="!isButtonVisible && panelOpenState ? 'fade-out-animation' : 'fade-in-animation'"
                            (click)="hideButton()">
                            <app-states-separator matBadge="3" matBadgeOverlap="false"
                                [state]="(transaction.attributes.state).toString()" [showDivider]="false"
                                [disabledTooltip]="panelOpenState"></app-states-separator>
                        </div>
                    </div>
                    <div *ngIf="!publicTransaction" class="table-cell">
                        <app-btn-transaction-details [transaction]="transaction"></app-btn-transaction-details>
                    </div>
                </div>
            </div>
        </mat-expansion-panel-header>
        <app-stepper-transaction-states
            [beforepath]="!publicTransaction ? 'users/' + globalStateService.userId + '/transactions/' + transaction.id : ''"
            [transaction]="transaction"></app-stepper-transaction-states>
    </mat-expansion-panel>

    <div *ngIf="transaction_list_mobile">
        <button mat-stroked-button (click)="mep.toggle()">
            <mat-icon>{{panelOpenState ? 'expand_less': 'expand_more'}}</mat-icon>
        </button>
    </div>
    <mat-divider *ngIf="!isLast"></mat-divider>

</mat-accordion>

<div class="container-divider">
    <mat-divider *ngIf="!isLast"></mat-divider>
</div>

<ng-template #transactionListMobile>
    <div (click)="setUrlDetail()">
        <div class="table-row">
            <div class="table-cell mid-transaction-cell">
                <p class="mid-transaction">Pedido {{transaction.attributes.mid}}</p>
                <app-states-separator matBadge="3" matBadgeOverlap="false"
                    [state]="(transaction.attributes.state).toString()" [showDivider]="false"></app-states-separator>
            </div>
        </div>
        <div class="table-row">
            <div class="table-cell">
                <app-system-picture class="system-picture"
                    [systemId]="(opacity ? transaction.relationships.system1.data?.id + '-comprar' : transaction.relationships.system1.data?.id )?? ''"
                    [alt]="transaction.relationships.system1.data!.attributes.name"
                    title="Comprar/Vender {{transaction.relationships.system1.data!.attributes.name}}"></app-system-picture>
                <div class="container-horizontal-line">
                    <div class="horizontal-dotted-line"></div>
                </div>
                <app-system-picture class="system-picture"
                    [systemId]="(opacity ? transaction.relationships.system2.data?.id + '-comprar' : transaction.relationships.system2.data?.id )?? ''"
                    [alt]="transaction.relationships.system2.data!.attributes.name"
                    title="Comprar/Vender {{transaction.relationships.system2.data!.attributes.name}}"></app-system-picture>
            </div>
        </div>
        <div class="table-row">
            <div class="table-cell mobile">
                <p class="number-amount">{{transaction.attributes.amount1 | decimalBySystem:
                    transaction.relationships.system1.data!}}
                    <span class="secondary-text">{{transaction.relationships.system1.data!.attributes.currency}}</span>
                </p>
                <p class="number-amount">{{transaction.attributes.amount2 | decimalBySystem:
                    transaction.relationships.system2.data!}}
                    <span class="secondary-text">{{transaction.relationships.system2.data!.attributes.currency}}</span>
                </p>
            </div>
        </div>
    </div>

</ng-template>
